module.exports = __webpack_public_path__ + "static/john-ashley-classic-car-specialist-edaa0bebcc3d0d82b919d54f55789ff9.jpg";